export const TENANT = {
    /** Admin, Pro Web 인증을 시도하는 경우 사용하는 MS 테넌트 값 */
    PARTNERS: 'Partners',
    /** Homeowner Web 인증을 시도하는 경우 사용하는 MS 테넌트 값 */
    HOMEOWNER: 'Homeowner',
};
